import * as React from 'react';

import * as styles from './styles.css';

export interface IRealtorsListingLayoutProps {
  banner: React.ReactNode;
  list: React.ReactNode;
  pagination?: React.ReactNode;
  scrolledElementRef: React.RefObject<HTMLDivElement>;
}

export const RealtorsListingLayout: React.FC<React.PropsWithChildren<IRealtorsListingLayoutProps>> = props => {
  const { pagination, banner, list, scrolledElementRef } = props;

  return (
    <div className={styles['wrapper']}>
      <div className={styles['banner']}>{banner}</div>
      <div className={styles['list']} ref={scrolledElementRef}>
        {list}
        {pagination && <div className={styles['pagination']}>{pagination}</div>}
      </div>
    </div>
  );
};

RealtorsListingLayout.displayName = 'RealtorsListingLayout';
